import React from 'react';
import { DictionarySearch } from './DictionarySearch';
import { trackEvent, useReadCloudAuth } from '@readcloud/common';
import { tauriFetch } from '@readcloud/fetch-wrapper';
import { ABSOLUTE_PATH } from '@readcloud/state';

interface Props {
  query: string;
  onClose?: () => void;
}

export const DictionaryPopover: React.FC<Props> = ({ ...props }) => {
  const [loading, setLoading] = React.useState<boolean>(true);
  const [error, setError] = React.useState<string>();
  const [result, setResult] = React.useState<string>();
  const { user } = useReadCloudAuth();

  React.useEffect(() => {
    trackEvent('Webapp/DictionaryUsed', { query: props.query });
    const getResults = async () => {
      try {
        const res = await tauriFetch(
          `${ABSOLUTE_PATH}/api/v14/dictionary?text=${encodeURIComponent(props.query)}`,
          {
            headers: {
              Authorization: `Bearer ${user?.accessToken}`,
            },
            method: 'GET',
          }
        );
        if (!res.ok) {
          throw new Error('Dictionary fetch failed');
        }
        if (!res.body) {
          throw new Error('Response body is null');
        }
        const responseStream = res.body.pipeThrough(new TextDecoderStream()).getReader();
        setLoading(false);
        let currentResult = '';
        while (true) {
          const chunk = await responseStream.read();
          if (chunk.value) {
            setResult((res) => (res || '') + chunk.value);
            currentResult += chunk.value;
          }
          if (chunk.done) {
            break;
          }
        }
        trackEvent('Webapp/DictionaryResultShown', {
          query: props.query,
          result: currentResult,
        });
      } catch (e) {
        setError(String(e));
        setLoading(false);
      }
    };

    getResults();
  }, [user?.accessToken, props.query]);

  return (
    <>
      <div className="rc-flex rc-flex-col">
        <DictionarySearch
          loading={loading}
          query={props.query}
          definition={result}
          error={error}
        />
      </div>
    </>
  );
};
